import React, { useState } from "react";
import { useNavigate, Link, Navigate } from "react-router-dom";
import { useCustomerAuth } from "@/context/CustomerAuthContext";
import PublicLayout from "@/components/public/PublicLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function CustomerLogin() {
  const { login, customer } = useCustomerAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  if (customer) return <Navigate to="/account" replace />;

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await login(email.trim().toLowerCase(), password); toast.success("Welcome back"); navigate("/account"); }
    catch (err) { toast.error(err.response?.data?.detail || "Login failed"); }
    finally { setBusy(false); }
  };

  return (
    <PublicLayout>
      <section className="max-w-md mx-auto px-5 py-20">
        <div className="text-center mb-8">
          <div className="text-[#c9a86a] tracking-[0.3em] text-xs mb-2">CLIENT ACCESS</div>
          <h1 className="text-2xl font-semibold text-[var(--text)]">Sign in to your account</h1>
        </div>
        <form onSubmit={submit} className="bg-[var(--panel-2)] border border-[var(--border-2)] rounded-xl p-8 space-y-5" data-testid="customer-login-form">
          <div className="space-y-2"><Label className="text-[var(--text-2)]">Email</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="bg-[var(--bg)] border-[var(--border-2)] text-[var(--text)]" data-testid="cust-login-email" /></div>
          <div className="space-y-2"><Label className="text-[var(--text-2)]">Password</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="bg-[var(--bg)] border-[var(--border-2)] text-[var(--text)]" data-testid="cust-login-password" /></div>
          <Button type="submit" disabled={busy} data-testid="cust-login-submit" className="w-full bg-[#c9a86a] hover:bg-[#b89455] text-[var(--on-gold)] font-semibold rounded-none">{busy ? "Signing in…" : "Sign In"}</Button>
        </form>
        <p className="text-center text-sm text-[var(--muted)] mt-6">
          New here? <Link to="/account/register" className="text-[#c9a86a] hover:text-[#b89455] transition-colors">Create an account</Link> or <Link to="/vip" className="text-[#c9a86a] hover:text-[#b89455] transition-colors">join the VIP list</Link>.
        </p>
      </section>
    </PublicLayout>
  );
}
